import { render, staticRenderFns } from "./Behold.vue?vue&type=template&id=04f29a66&scoped=true&"
import script from "./Behold.vue?vue&type=script&lang=js&"
export * from "./Behold.vue?vue&type=script&lang=js&"
import style0 from "./Behold.vue?vue&type=style&index=0&id=04f29a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f29a66",
  null
  
)

export default component.exports